import { createFileRoute } from "@tanstack/react-router";

import { RobotPage } from "../../workspaces/build/pages/RobotsPage";
import { useProjectId } from "../../shell/project";

export const Route = createFileRoute("/_console/p/$org/$project/robots/bodies/$body")({
  component: OneRobot,
});

/** One robot, at its own address.
 *
 * A robot's name is unique in each registry, so which one is open is a coordinate and not
 * a filter that happened to select one row. The name sits under `bodies` so no robot's
 * name can ever be read as a page of Robots. */
function OneRobot() {
  const projectId = useProjectId();
  const { body } = Route.useParams();
  return <RobotPage projectId={projectId} name={body} />;
}
